import React, { useState } from 'react';
import UserTable from './UserTable';
import GameStatsTable from './GameStatsTable';
import AchievementManagementTable from './AchievementManagementTable';

const UserManagementPanel = ({
  users,
  selectedUser,
  userGameStats,
  loading,
  pagination,
  onUserSelect,
  onUserEdit,
  searchTerm,
  onSearch,
  onPageChange,
  onStatsUpdate,
  sortBy,
  sortOrder,
  onSort
}) => {
  const [activeTab, setActiveTab] = useState('stats');
  return (
    <div className="user-management-panel">
      {/* User Management Section */}
      <div className="admin-page__section">
        <h2>User Management</h2>
        <UserTable
          users={users}
          loading={loading}
          pagination={pagination}
          onUserSelect={onUserSelect}
          onUserEdit={onUserEdit}
          searchTerm={searchTerm}
          onSearch={onSearch}
          onPageChange={onPageChange}
          selectedUser={selectedUser}
          sortBy={sortBy}
          sortOrder={sortOrder}
          onSort={onSort}
        />
      </div>

      {/* User Details Section */}
      {selectedUser && (
        <div className="admin-page__section">
          <h2>Details for: {selectedUser.username}</h2>
          <div className="admin-page__user-details">
            <table className="admin-page__user-details-table">
              <tbody>
                <tr>
                  <td className="admin-page__user-details-label">ID:</td>
                  <td className="admin-page__user-details-value">{selectedUser.id}</td>
                </tr>
                <tr>
                  <td className="admin-page__user-details-label">Email:</td>
                  <td className="admin-page__user-details-value">{selectedUser.email}</td>
                </tr>
                <tr>
                  <td className="admin-page__user-details-label">Role:</td>
                  <td className="admin-page__user-details-value">
                    <span className={`admin-page__role admin-page__role--${selectedUser.role}`}>{selectedUser.role}</span>
                  </td>
                </tr>
                <tr>
                  <td className="admin-page__user-details-label">Created:</td>
                  <td className="admin-page__user-details-value">{new Date(selectedUser.created_at).toLocaleDateString()}</td>
                </tr>
                <tr>
                  <td className="admin-page__user-details-label">Last Activity:</td>
                  <td className="admin-page__user-details-value">{selectedUser.updated_at ? new Date(selectedUser.updated_at).toLocaleDateString() : 'Never'}</td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* Tabbed Section */}
          <div className="admin-page__tabbed-section">
            <div className="admin-page__tab-nav">
              <button 
                className={`admin-page__tab-btn ${activeTab === 'stats' ? 'admin-page__tab-btn--active' : ''}`}
                onClick={() => setActiveTab('stats')}
              >
                Game Statistics
              </button>
              <button 
                className={`admin-page__tab-btn ${activeTab === 'achievements' ? 'admin-page__tab-btn--active' : ''}`}
                onClick={() => setActiveTab('achievements')}
              >
                Achievements
              </button>
            </div>
            
            <div className="admin-page__tab-content">
              {activeTab === 'stats' && (
                <GameStatsTable
                  gameStats={userGameStats}
                  userId={selectedUser.id}
                  onStatsUpdate={onStatsUpdate}
                />
              )}
              
              {activeTab === 'achievements' && (
                <AchievementManagementTable
                  userId={selectedUser.id}
                  username={selectedUser.username}
                />
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default UserManagementPanel;